import axios from 'axios'
import { BASE_URL } from '../constants/api'
import { toast } from '@helps/toast'

const DEFAULT_ERROR_MESSAGE = 'Произошла ошибка'

const isUselessMessage = value =>
  !value || (typeof value === 'string' && /^error$/i.test(value.trim()))

const isHtml = value =>
  typeof value === 'string' && value.trim().startsWith('<')

const getApiErrorMessage = data => {
  if (!data) return DEFAULT_ERROR_MESSAGE
  if (typeof data === 'string') {
    return isUselessMessage(data) || isHtml(data)
      ? DEFAULT_ERROR_MESSAGE
      : data
  }
  if (typeof data !== 'object') return DEFAULT_ERROR_MESSAGE

  if (data.error) {
    if (typeof data.error === 'string') {
      if (!isUselessMessage(data.error)) return data.error
    } else if (typeof data.error === 'object') {
      if (!isUselessMessage(data.error.result)) return data.error.result
      if (!isUselessMessage(data.error.message)) return data.error.message
      if (!isUselessMessage(data.error.description)) return data.error.description
    }
  }

  if (!isUselessMessage(data.description)) return data.description
  if (typeof data.detail === 'string' && !isUselessMessage(data.detail)) {
    return data.detail
  }

  if (typeof data.result === 'string' && !/^error$/i.test(data.result)) {
    return data.result
  }

  return DEFAULT_ERROR_MESSAGE
}

export const configureApi = store => {
  const instance = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
  })

  instance.interceptors.response.use(
    response => {
      if (
        response.data &&
        typeof response.data === 'object' &&
        String(response.data.result).toLowerCase() === 'error'
      ) {
        toast.error(getApiErrorMessage(response.data))
      }
      return response
    },
    error => {
      const status = error.response?.status
      const data = error.response?.data

      const isApiError =
        data &&
        typeof data === 'object' &&
        String(data.result).toLowerCase() === 'error'

      if (typeof status === 'number' && status >= 500) {
        const message = getApiErrorMessage(data)
        toast.error(
          message === DEFAULT_ERROR_MESSAGE
            ? `Ошибка сервера (${status})`
            : message
        )
      } else if (isApiError) {
        toast.error(getApiErrorMessage(data))
      }

      return Promise.reject(error)
    }
  )

  return instance
}
